import React from 'react';
import {
    Box,
    Chip,
    Link,
    Stack,
    Typography,
} from '@mui/material';
import CoverageSourceMeter from './CoverageSourceMeter';
import {COVERAGE_SOURCE} from '../coverageSourceTheme';
import {
    materialCoverageExplanation,
    resolveMaterialCccPct,
} from '../buildCollectionCoverageView';
import {toCoverageRationalePhrase} from '../../pirCoverageDisplay';

/**
 * Collection material (CM / IIR) evidence row inside a Data pane.
 */
export default function CoverageMaterialRow({material, onOpen}) {
    const kind = material.materialKind === 'iir' ? 'IIR' : 'CM';
    const displayId = material.displayId
        || material.humanId
        || material.cmNumber
        || material.iirNumber
        || material.id;
    const title = material.title || displayId;
    const clickable = typeof onOpen === 'function' && Boolean(material?.id);
    const cccPct = resolveMaterialCccPct(material);
    const explanation = toCoverageRationalePhrase(materialCoverageExplanation(material));

    const handleOpen = (event) => {
        event.stopPropagation();
        onOpen?.(material);
    };

    return (
        <Stack
            spacing={0.75}
            sx={{
                p: 1.25,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: 'background.paper',
            }}
        >
            <Stack direction="row" spacing={1} alignItems="flex-start" useFlexGap>
                {clickable ? (
                    <Link
                        component="button"
                        variant="caption"
                        onClick={handleOpen}
                        sx={{flexShrink: 0, p: 0, minWidth: 0, textDecoration: 'none'}}
                    >
                        <Chip
                            label={kind}
                            size="small"
                            clickable
                            sx={{height: 20, fontSize: '0.65rem'}}
                        />
                    </Link>
                ) : (
                    <Chip label={kind} size="small" sx={{height: 20, fontSize: '0.65rem', flexShrink: 0}}/>
                )}
                <Box minWidth={0} flex={1}>
                    {clickable ? (
                        <Link
                            component="button"
                            variant="body2"
                            onClick={handleOpen}
                            sx={{
                                fontWeight: 600,
                                textAlign: 'left',
                                display: 'block',
                                maxWidth: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                            title={title}
                        >
                            {title}
                        </Link>
                    ) : (
                        <Typography variant="body2" fontWeight={600} noWrap title={title}>
                            {title}
                        </Typography>
                    )}
                    {displayId && displayId !== title && (
                        <Typography variant="caption" color="text.secondary" noWrap title={displayId}>
                            {displayId}
                        </Typography>
                    )}
                </Box>
            </Stack>
            {cccPct != null && (
                <CoverageSourceMeter
                    pct={cccPct}
                    color={COVERAGE_SOURCE.DATA.color}
                    track={COVERAGE_SOURCE.DATA.track}
                    height={4}
                />
            )}
            {explanation ? (
                <Typography variant="caption" color="text.disabled" sx={{lineHeight: 1.4}}>
                    {explanation}
                </Typography>
            ) : null}
        </Stack>
    );
}
